import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {LoginProvider} from '../../providers/login/login';
import {GlobalProvider} from '../../providers/global/global';
import {HomePage} from '../home/home';
import {PwaProvider} from '../../providers/pwa/pwa';


@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  email: string;
  clave: string;
  idUsuario: any;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private loginProvider: LoginProvider,
              private global: GlobalProvider,
              private pwa: PwaProvider) {
  }

  login(){
    this.loginProvider.login(this.email, this.clave).subscribe(data => {
      console.log("login", data);
      if (Object.keys(data).length === 0) {
        this.global.crearToast("Usuario o clave errónea", 1500);
      } else {
        if (data["activo"]) {
          this.global.setlogged(true);
          this.global.setDataUser(data);

          var ukt = this.global.calcula_ukt(this.email, this.clave);

          this.global.setukt(ukt);

          this.idUsuario = data["id"];

          this.pwa.enableNotifications(this.idUsuario);

          this.navCtrl.setRoot(HomePage);
        } //Activo
        else {
          this.global.crearToast("Usuario no activo", 1500, "bottom");
        }
      }
    });

  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts